import ExpoPartecipazioniService from "services/API/expo_partecipazioni/ExpoPartecipazioniService";
import base64ToArrayBuffer from "./base64ToArrayBuffer";

async function genera_contratto(id_partecipazione) {
    console.log("download_pdf :" + id_partecipazione);
        if (id_partecipazione != 0) {
            let filename = 'ContrattoAgriumbria.pdf';
    
            ExpoPartecipazioniService.genera_pdf_contratto(id_partecipazione)
                .then(response => {
                    
                    return response.data;
                })
                .then(blob => {
    
                    var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
                    var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
                    var url = URL.createObjectURL(blobb);
                    var a = document.createElement('a');
                    a.href = url;
                    a.target = "_blank";
                    a.download = filename;
                    document.body.appendChild(a); // append the element to the dom
                    a.click();
                    a.remove(); // afterwards, remove the element  
                })
                .catch(error => {
                    console.error(error);
                });
    
    
        }
}
export default genera_contratto;